// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Sgeon","text":"styles_text__8TmyI"};